import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from '../Services/cookie';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { Location } from "@angular/common";
import { CardServiceService } from '../Services/card-service.service';


@Component({
  selector: 'app-enter-mobile-pin',
  templateUrl: './enter-mobile-pin.component.html',
  standalone:false,
  styleUrls: ['./enter-mobile-pin.component.scss']
})
export class EnterMobilePinComponent implements OnInit {
  Pin1: string = "";
  Pin2: string = "";
  otp: string = "";
  internalId: string;
  NewLimit: string;

  timerexpire: string;
  OptTimerbtnShow: boolean = true;
  timeoutHandle;
  Mobile: string;
  Screen: string;
  maskemail: string;
  internalId2: string;
  constructor(private router: Router, private location: Location, public common: CommonService, public auth: AuthService,public cardService:CardServiceService, private cookieService: CookieService) { }


  back() {
    this.location.back();
  }

  async ngOnInit(): Promise<void> {

    this.auth.accessToken = await this.common.Get("token");
    // await this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
    //   if (data?.response?.code == 1) {
    //    await this.common.hideLoading();

    //   } 
    //   else {
    //     await this.common.hideLoading();
    //     this.common.ParseErrorAlert("", "", this.router, data);
    //   }
    // })
    this.startTime();

    let M =await this.cookieService.get("minfo",true);
    if(M){
      this.Mobile = M;
    }
    
    let E =await this.cookieService.get("eRef",true);
    if(E){
      this.maskemail = E;
    }

    let S =await this.cookieService.get("Screen",true);
    if(S){
      this.Screen = S;
    }

    let a =await this.cookieService.get("AutoTempLimitObj",true);
    if(a){
      this.cardService.AutoTempLimitObj = JSON.parse(a);
    }


    let Id =await this.cookieService.get("internalid", true);
    if (Id) {

      this.internalId = Id;

    }
    let inID =await this.cookieService.get("InternallID", true);
    if (inID) {

      this.internalId2 = inID;

    }

    let N =await this.cookieService.get("NewLimit", true);
    if (N) {

      this.NewLimit = N;

    }

  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === "Enter") {
      // this.Login();
    }
  }


  onOtpChange(e) {
    if (e.length == 6) {
      this.otp = e.toString();
    } else {
      this.otp = null;
    }
  }

  VerifySMSOTPSetLimit() {
    this.common.presentLoading();

    if(this.Screen == "Reissue"){

      let body = {
        OTPCode: this.otp,
        internalCardId: this.internalId2
       
      }
  
      this.auth.ReIssueCardPinVerifyOtp(body, this.auth.accessToken).then((res: any) => {

        if (res?.response?.code == 1) {
          this.common.hideLoading();
          this.router.navigateByUrl('/PayCardSuccess')
  
        }
        else if(res?.error?.response?.code == 7){
          this.common.hideLoading();
          this.router.navigateByUrl('/PayCardSuspended')
          this.common.ParseErrorAlert("", "OK", this.router, res);
  
        }
        else {
          this.common.hideLoading();
          this.router.navigateByUrl('/PayCardSuspended')
          this.common.ParseErrorAlert("", "OK", this.router, res);
        }
      })

    }
    else{
      let body = {
        OTPCode: this.otp,
        CardId: this.internalId,
        RequestId: this.cardService.AutoTempLimitObj.limitRequestId,
        limitType: "TEMPLIMIT",
        NewLimit: this.NewLimit
      }
  
      this.auth.VerifySMSOTPSetLimit(body, this.auth.accessToken).then((res: any) => {

        if (res?.response?.code == 1) {
          this.common.hideLoading();
          this.router.navigateByUrl('/PayCardReview')
  
        }
        else if(res?.error?.response?.code == 7){
          this.common.hideLoading();
          this.common.ParseErrorAlert("", "OK", this.router, res);
  
        }
        else {
          this.common.hideLoading();
          this.common.ParseErrorAlert("", "OK", this.router, res);
        }
      })
    }
    
  }

  ResendOtp() {
    this.common.presentLoading();

    if(this.Screen == "Reissue"){
        this.auth.ReIssueCardPinOtp(this.auth.accessToken).then((res:any)=>{
          if(res?.response?.code == 1){
            this.common.hideLoading();
            
          }
          else{
            this.common.hideLoading();
          this.common.ParseErrorAlert("","OK",this.router,res);
    
          }
        })
      
    }
    else{
      this.auth.LimitResendSMSOTP(this.auth.accessToken).then((res: any) => {

        if (res?.response.code == 1) {
          this.OptTimerbtnShow = true;
          this.startTime();
          this.common.hideLoading();
        }
        else {
          this.common.hideLoading();
          this.common.ParseErrorAlert("", "OK", this.router, res);
        }
      })
    }
   
  }

  // startTime() {
  //   var str = "1:57";

  //   var array = str.split(":");
  //   this.countdown(parseInt(array[0]), parseInt(array[1]));
  // }

  // countdown(minutes, seconds) {
  //   this.timeoutHandle;
  //   var that = this;
  //   function tick() {
  //     that.timerexpire =
  //       minutes.toString() + ":" + (seconds < 10 ? "0" : "") + String(seconds);
  //     seconds--;
  //     if (seconds >= 0) {
  //       that.timeoutHandle = setTimeout(tick, 1000);
  //     } else {
  //       if (minutes >= 1) {
  //         setTimeout(function () {
  //           that.countdown(minutes - 1, 59);
  //         }, 1000);
  //       }
  //     }

  //     if (that.timerexpire == "0:00") {
  //       that.OptTimerbtnShow = false;
  //     }
  //   }
  //   tick();
  // }

    // new timer
  startTime() {
  const expireTime = new Date().getTime() + 2 * 60 * 1000; // 2 minutes from now
  this.startCountdown(expireTime);
}

startCountdown(expireTimestamp: number) {
  const tick = () => {
    const now = new Date().getTime();
    const remaining = expireTimestamp - now;

    if (remaining <= 0) {
      this.timerexpire = "0:00";
      this.OptTimerbtnShow = false;
      return;
    }

    const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

    this.timerexpire = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    setTimeout(tick, 1000);
  };

  tick();
}


}
